import utils from '../../utils/tag-name';

const TAG_NAME = utils.constructTagName('illustration');

const DEFAULTS = {
  NAME: undefined,
} as const;

export { TAG_NAME, DEFAULTS };
